"use client";

import { ArrowUp, Facebook, Instagram, Youtube } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function SiteFooter() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  return <section data-section-id="122096" id="footer" className="bg-[#fafbf1] text-black border-t border-[#d6d1bb] py-12 px-8 font-sans text-[0.8rem]">
      <div className="mx-auto max-w-7xl flex flex-col gap-12">
        {}
        <div className="flex flex-col items-center justify-between gap-6 md:flex-row">
          <Link to="/HomePage">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1608537/img/if1_air_racing_logo_footer.png" alt="NB Socials" className="h-7 w-auto" />
          </Link>
          <div className="flex items-center gap-6">
            <Link to="#" aria-label="Instagram" className="text-black hover:text-[#35bdfe] transition-colors">
              <Instagram className="size-5" />
            </Link>
            <Link to="#" aria-label="YouTube" className="text-black hover:text-[#35bdfe] transition-colors">
              <Youtube className="size-5" />
            </Link>
            <Link to="#" aria-label="Facebook" className="text-black hover:text-[#35bdfe] transition-colors">
              <Facebook className="size-5" />
            </Link>
          </div>
        </div>

        {}
        <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
          <p className="text-[#000000]/60">
            &copy; {new Date().getFullYear()} Now Brand Socials. All rights reserved.
          </p>
          <Button variant="ghost" size="sm" onClick={scrollToTop} className="text-[0.8rem] text-black hover:text-[#35bdfe] hover:bg-transparent px-0 transition-colors">
            Back to top
            <ArrowUp className="ml-2 size-4" />
          </Button>
        </div>
      </div>
    </section>;
}